module.exports = __webpack_public_path__ + "static/tow-truck1-fb68c5782bfe3c92ab01de8278f6ece9.jpg";